const { PSM_NG_NATIONAL_LOCATION_ID } = require('./constants')

const isValidLocationId = id =>
  (id.startsWith('country:') || // SL format and new PSM id format
  id.startsWith('zone:') || // old PSM NG id format
  id === PSM_NG_NATIONAL_LOCATION_ID) // old PSM NG national id

module.exports = isValidLocationId
